export const painPoints = [
  'No sabés si el precio que te pasan es justo.',
  'Te da miedo comprar un usado con problemas.',
  'No querés perder días recorriendo agencias.',
  'No sabés cuánto vale realmente tu usado.',
  'La financiación te genera dudas.',
  'Temés que te cambien las condiciones a último momento.',
]

export type Benefit = {
  title: string
  text: string
  icon: 'search' | 'repeat' | 'wallet' | 'scale' | 'chat' | 'calendar'
}

export const benefits: Benefit[] = [
  {
    title: 'Búsqueda personalizada',
    text: 'Te mostramos opciones según marca, modelo, presupuesto y necesidad.',
    icon: 'search',
  },
  {
    title: 'Usado en parte de pago',
    text: 'Podés consultar la toma de tu vehículo actual para cambiarlo por otro.',
    icon: 'repeat',
  },
  {
    title: 'Financiación',
    text: 'Te orientamos con alternativas para avanzar con anticipo y cuotas.',
    icon: 'wallet',
  },
  {
    title: 'Comparación inteligente',
    text: 'Comparamos precio, estado, equipamiento, consumo y valor de reventa.',
    icon: 'scale',
  },
  {
    title: 'Asesoramiento real',
    text: 'Respondemos tus dudas antes de que tomes una decisión.',
    icon: 'chat',
  },
  {
    title: 'Visita coordinada',
    text: 'Si una unidad te interesa, coordinamos para que puedas verla con tranquilidad.',
    icon: 'calendar',
  },
]

export const steps = [
  {
    title: 'Nos contás qué auto buscás',
    text: 'Marca, modelo, presupuesto, zona, forma de pago y si tenés usado para entregar.',
  },
  {
    title: 'Revisamos opciones disponibles',
    text: 'Buscamos alternativas que se ajusten a lo que necesitás.',
  },
  {
    title: 'Te ayudamos a comparar',
    text: 'Analizamos precio, estado, financiación, equipamiento y conveniencia.',
  },
  {
    title: 'Coordinamos el próximo paso',
    text: 'Si una unidad te interesa, avanzamos con visita, reserva o asesoramiento para la compra.',
  },
]

export type Path = {
  title: string
  text: string
  cta: string
  /** Link de WhatsApp propio de esta tarjeta — editalo acá. */
  url: string
  icon: 'car' | 'repeat' | 'wallet' | 'users' | 'truck' | 'shield'
}

export const paths: Path[] = [
  {
    title: 'Quiero comprar mi primer auto',
    text: 'Te ayudamos a elegir una opción confiable, económica y fácil de mantener.',
    cta: 'Buscar mi primer auto',
    url: 'https://wa.me/message/YRVFDIQWAIUNM1',
    icon: 'car',
  },
  {
    title: 'Quiero cambiar mi auto',
    text: 'Consultá por toma de usado en parte de pago y opciones para subir de modelo.',
    cta: 'Cambiar mi auto',
    url: 'https://wa.me/p/28323247353965931/5491156449518',
    icon: 'repeat',
  },
  {
    title: 'Necesito financiación',
    text: 'Te orientamos con alternativas para comprar con anticipo y cuotas.',
    cta: 'Consultar financiación',
    url: 'https://wa.me/p/37594982293479968/5491156449518',
    icon: 'wallet',
  },
  {
    title: 'Busco un auto familiar',
    text: 'Encontrá más espacio, comodidad y seguridad para tu familia.',
    cta: 'Ver opciones familiares',
    url: 'https://wa.me/p/27549916584691244/5491156449518',
    icon: 'users',
  },
  {
    title: 'Necesito un vehículo para trabajar',
    text: 'Buscamos opciones útiles para generar ingresos o potenciar tu negocio.',
    cta: 'Buscar vehículo de trabajo',
    url: 'https://wa.me/p/28233644609619670/5491156449518',
    icon: 'truck',
  },
  {
    title: 'Quiero un usado confiable',
    text: 'Te ayudamos a encontrar unidades seleccionadas y listas para avanzar.',
    cta: 'Ver usados disponibles',
    url: 'https://wa.me/p/28323247353965931/5491156449518',
    icon: 'shield',
  },
]

export const trustPoints = [
  'Atención personalizada',
  'Opciones según tu presupuesto',
  'Asesoramiento por WhatsApp',
  'Posibilidad de entregar tu usado',
  'Consulta de financiación',
  'Coordinación de visitas',
  'Información clara antes de avanzar',
]

export const faqs = [
  {
    q: '¿Tengo que pagar para consultar?',
    a: 'No. Podés escribirnos y contarnos qué estás buscando para recibir orientación inicial.',
  },
  {
    q: '¿Puedo entregar mi usado en parte de pago?',
    a: 'Sí. Podés consultarnos por la toma de tu vehículo actual y ver opciones para cambiarlo.',
  },
  {
    q: '¿Trabajan con financiación?',
    a: 'Podemos orientarte con alternativas disponibles para comprar con anticipo y cuotas, según el caso.',
  },
  {
    q: '¿Puedo ver el auto antes de decidir?',
    a: 'Sí. Si una unidad te interesa, coordinamos el próximo paso para que puedas verla y resolver tus dudas.',
  },
  {
    q: '¿Qué datos tengo que enviar?',
    a: 'Marca o tipo de auto que buscás, presupuesto, zona, forma de pago y si tenés usado para entregar.',
  },
]

export const closingChecklist = [
  'Qué auto buscás',
  'Cuál es tu presupuesto',
  'Si tenés usado para entregar',
  'Si necesitás financiación',
  'En qué zona estás',
]

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/357a708d-add6-4c64-b323-36d3d1a4103d.jpg',
  keys: 'https://cdn.magicpatterns.com/patterns/generated-images/f5470dfb-0a57-42e8-813e-f1f44843cea0.jpg',
  advisor:
    'https://cdn.magicpatterns.com/patterns/generated-images/72aa9fff-0fc7-4deb-a12c-431faccf4889.jpg',
  interior:
    'https://cdn.magicpatterns.com/patterns/generated-images/2100be9d-223a-49a8-a92a-3b2919f6489c.jpg',
}
